module.exports = __webpack_public_path__ + "img/kr-product-agency-card2-bg.f1a20fd.png";